import styled from "styled-components";
import { Popup } from "../../../Popup/Popup";
import { useModal } from "../../../../hooks/useModal";
import { HourlyWeather, WeatherState } from "./WeatherUtils";
import WeatherPreviewPopup from "./WeatherPreviewPopup";
import { Stack, Typography } from "@mui/material";
import { GameContext } from "../../../../contexts/GameContext";
import { useContext, useEffect } from "react";
import { ImageService } from "../../../../services/image/imageService";
import IconTemp from "./IconTemp";


interface Props {
    weather: HourlyWeather[],
}


const Weather = ({ weather }: Props) => {
    const { isShown: showPopup, toggle: togglePopup } = useModal();
    const { tempIn, tempExt, weatherIdx, round, currentStep } = useContext(GameContext);

    return (
        <Stack direction="row" gap={2} style={{ "alignItems": "center" }}>
            <WeatherWindow>
                <StyledButton style={{ "padding": "0", "border": "none", "backgroundColor": "transparent", "display": "flex" }} >
                    <IconTemp />
                    {/*
                    {weatherIdx[round][currentStep] === WeatherState.SUNNY && <img src={ImageService.getImgUrl("weather-sunny")} width={"100%"} height={"100%"} alt="Soleil." />}
                    {weatherIdx[round][currentStep] === WeatherState.PARTIAL && <img src={ImageService.getImgUrl("weather-partial")} width={"100%"} height={"100%"} alt="Partiel." />}
                    {weatherIdx[round][currentStep] === WeatherState.RAIN && <img src={ImageService.getImgUrl("weather-rain")} width={"100%"} height={"100%"} alt="Pluie." />}
                    {weatherIdx[round][currentStep] === WeatherState.CLOUDS && <img src={ImageService.getImgUrl("weather-clouds")} width={"100%"} height={"100%"} alt="Nuages." />}
                    {weatherIdx[round][currentStep] === WeatherState.THUNDER && <img src={ImageService.getImgUrl("weather-thunder")} width={"100%"} height={"100%"} alt="Éclair." />}
                    */}
                </StyledButton>

            </WeatherWindow>
            <Stack direction="column">
                <Box className="box-en-ligne">
                    <Typography className="font-list" variant="h5" sx={{ fontWeight: "bold" }}>{tempIn.toFixed(1)}°C</Typography>
                    <Label className="font-list">intérieur</Label>
                </Box>
                <Box className="box-en-ligne">
                    <Typography className="font-list" variant="h5" sx={{ fontWeight: "bold" }}>{tempExt[round][currentStep]}°C</Typography>
                    <Label className="font-list">extérieur</Label>
                </Box>
            </Stack>

            <Popup
                isShown={showPopup}
                hide={togglePopup}
                headerText={"Météo"}
                modalContent={<WeatherPreviewPopup previsions={weather} />}
            />
        </Stack>
    );
};


const WeatherWindow = styled.div`
    width: 30%;
`;

const Box = styled.div`
    display: flex;
    flex-direction: column;
`;

const Label = styled.div`
    font-size: .8rem;
    padding: .1em;
`;

export const StyledButton = styled.button`
    background: #fff;
    backface-visibility: hidden;
    border-radius: .375rem;
    border-style: solid;
    border-width: .125rem;
    box-sizing: border-box;
    color: #212121;
    cursor: pointer;
    display: inline-block;
    font-family: Circular,Helvetica,sans-serif;
    font-size: .9rem;
    font-weight: 700;
    letter-spacing: -.01em;
    line-height: 1.3;
    padding: .875rem 1.125rem;
    position: relative;
    text-align: left;
    text-decoration: none;
    transform: translateZ(0) scale(1);
    transition: transform .2s;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    }

    :not(:disabled):hover {
        transform: scale(1.05);
    }

    :not(:disabled):hover:active {
        transform: scale(1.05) translateY(.125rem);
    }

    :focus {
        outline: 0 solid transparent;
    }

    :focus:before {
        content: "";
        left: calc(-1*.375rem);
        pointer-events: none;
        position: absolute;
        top: calc(-1*.375rem);
        transition: border-radius;
        user-select: none;
    }

    :focus:not(:focus-visible) {
        outline: 0 solid transparent;
    }

    :focus:not(:focus-visible):before {
        border-width: 0;
    }

    :not(:disabled):active {
        transform: translateY(.125rem);
    }
`;


export default Weather;